import { Link } from "react-router-dom";
import arrow from "../Assets/svgs/aboutArrow.svg";
import map from "../Assets/svgs/map.svg";
import me from "../Assets/images/about.png";
import { ReactComponent as Star } from "../Assets/svgs/stars.svg";

function AboutUs({ darkMode }) {
  const features = [
    {
      id: 1,
      description: "Strong Foundation in UX Research & UI Design. Every design decision is backed by user insights and data.",
    },
    {
      id: 2,
      description: "Frontend Development Expertise. Skilled in HTML, CSS, JavaScript, and React to build responsive, functional solutions.",
    },
    {
      id: 3,
      description: "Combination of Creativity & Technical Skills. Designs solve real problems and are visually appealing.",
    },
    {
      id: 4,
      description: "Collaborative Approach. Open to working together to create impactful, user-driven products.",
    },
  ];
  const startYear = 2022; // The year you started
  const currentYear = new Date().getFullYear();
  const experienceYears = currentYear - startYear;
  return (
    <>
      <div
        className={`h-fit 100:mt-[75vh] iphone:mt-[75vh] phone:mt-[50vh] sm:mt-[55vh] md:mt-[35vh] xl:mt-[5px] w-full 100:px-[40px] sm:px-16 py-24 ${darkMode ? "bg-[#0a0b5c]" : "bg-[#0609cd]"} flex-col justify-start items-center gap-2.5 inline-flex`}
      >
        <div className={`about  100:w-full 2xl:w-[1312px] 100:gap-[40px] lg:gap-[24px] flex-wrap pb-6 justify-between items-start inline-flex`}>
          <div className="  pb-[40px] md:flex-1  gap-[100px] flex flex-col 100:w-full md:w-[426px] justify-start items-center">
            <div className="  p-2.5 flex-col justify-start items-start gap-4 inline-flex">
              <div className="text-[40px] font-bold font-inter capitalize">
                <span className="text-[#f5f6f6] ">About </span>
                <span className="text-[#ffb600] ">Me</span>
              </div>
              <div className={`w-full ${darkMode ? "text-[#a9b2b7] " : "text-[#ccd2d5]"} text-base font-medium font-inter leading-[29px]`}>
                I'm a passionate Product Designer and Frontend Developer with {experienceYears}+ years of experience creating seamless digital experiences. My journey began with a fascination for how people interact with technology, driving me to
                craft intuitive, user-centered designs that are both visually appealing and highly functional.
              </div>
              <Link onClick={() => window.scrollTo(0, 0)} to="/contact">
                <div className="h-[43px] px-[25px] hover:bg-[#fd992f]  py-[5px] bg-[#ffb600] rounded-3xl shadow-customWhite justify-center items-center gap-2.5 inline-flex">
                  <div className="text-[#25282b] text-lg font-medium font-inter capitalize">Contact Me</div>
                </div>
              </Link>
            </div>
            <img className=" 100:rotate-90 md:rotate-0" src={arrow} alt="arrow" />
          </div>
          <div className={`h-[622px]  100:w-full md:w-[347px] px-6 pt-6 ${darkMode ? "bg-[#10169f]" : "bg-[#2f45ff]"} rounded-2xl backdrop-blur-[100px] flex-col justify-between items-center gap-8 inline-flex`}>
            <div className="w-full px-2.5 flex-col justify-start items-start gap-4 inline-flex">
              <div className="p-2.5 bg-[#ffb600] rounded-[999px] flex-col justify-center items-center gap-2.5 flex">
                <img src={map} alt="map" />
              </div>
              <h2 className="text-[#f5f6f6] text-[40px] font-semibold font-inter">100%</h2>
              <p className={`iphone:w-[279px] 100:w-full ${darkMode ? "text-[#a9b2b7]" : "text-[#e4e7e9]"} text-xl font-medium font-inter leading-[30px]`}>Average increase in client engagement in first 6 months</p>
            </div>
            <div className="  w-full">
              {" "}
              <img src={me} alt="Candy" />
            </div>
          </div>
          <div className="md:w-[460px]    100:w-full h-fit p-4 flex-col justify-start items-start gap-6 inline-flex">
            {features.map((item) => (
              <div key={item.id} className="w-full pb-2.5  flex-col justify-start items-start gap-6 inline-flex">
                <div className={`p-2.5 ${darkMode ? "bg-[#10169f]" : "bg-[#2f45ff]"} rounded-[999px] justify-center items-center  gap-2.5 flex`}>
                  <Star className="text-[#f5f6f6]" />
                </div>
                <p className={` text-[#f5f6f6] text-lg font-medium font-inter leading-[30px]`}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
